'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthsBefore;


// WEBPACK FOOTER //
// ./~/sugar-date/number/monthsBefore.js